var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: _vm.theme.checkbox
  }, [_c('div', [_c('div', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple",
      value: (_vm.rippleColor),
      expression: "rippleColor"
    }],
    class: _vm.theme.checkboxOverlay,
    on: {
      "click": _vm.handleClick
    }
  }), _vm._v(" "), _c('checkbox-raw', {
    attrs: {
      "value": _vm.value,
      "data": _vm.data,
      "theme": _vm.theme
    }
  })], 1), _vm._v(" "), _c('div', {
    class: _vm.theme.label
  }, [_vm._t("label", [_vm._v(_vm._s(_vm.label))])], 2)]), _vm._v(" "), (this.error) ? _c('div', {
    class: [_vm.theme.caption, _vm.theme.hasError]
  }, [_vm._t("error", [_vm._v("\n            " + _vm._s(this.error) + "\n        ")], {
    error: this.error
  })], 2) : _vm._e(), _vm._v(" "), (this.caption) ? _c('div', {
    class: _vm.theme.caption
  }, [_vm._t("caption", [_vm._v("\n            " + _vm._s(this.caption) + "\n        ")], {
    caption: this.caption
  })], 2) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dfcc51d","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/Checkbox/Checkbox.vue
// module id = 535
// module chunks = 0